import axios from 'axios'

// 埋点统计公用方法
const uid = Math.random().toString().slice(-8)
const uploadWebEventFn = function (eid, r, type, result) {
  let params = {
    uid: uid,
    eid: eid
  }
  if (r) {
    params['r'] = r
  }
  if (type !== '' && type !== void 0) {
    params['type'] = type
  }
  if (result !== '' && result !== void 0) {
    params['result'] = result
  }
  axios.get('/proxy-api/dpadmin/uploadWebEvent.php', {params: params})
}

export default function uploadWebEvent (type, params) {
  let fn = {
    // 注册页面输入并跳转到下一页面
    'SIGNUP_INPUT_NEXT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0000200') // 埋点统计：注册页面输入并跳转到邮箱注册页面
      } else if (params.type === 1) {
        uploadWebEventFn('0000000') // 埋点统计：注册页面输入并跳转到手机号注册页面
      } else if (params.type === 2) {
        uploadWebEventFn('0000100') // 埋点统计：注册页面输入并跳转到用户名注册页面
      }
    },
    // 注册页面返回上一步
    'SIGNUP_BACK': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0000220') // 埋点统计：邮箱注册密码输入页返回上一步
      } else if (params.type === 1) {
        uploadWebEventFn('0000020') // 埋点统计：手机号注册姓名密码页返回上一步
      } else if (params.type === 2) {
        uploadWebEventFn('0000120') // 埋点统计：用户名注册密码输入页返回上一步
      } else if (params.type === 3) {
        uploadWebEventFn('0000050') // 埋点统计：手机号注册输入验证码页面返回上一步
      }
    },
    // 注册密码完成页输入错误
    'SIGNUPNEXT_DONE_ERROR': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0000230') // 埋点统计：邮箱注册密码输入页密码输入错误
      } else if (params.type === 1) {
        uploadWebEventFn('0000060') // 埋点统计：手机号注册输入验证码页面输入错误
      } else if (params.type === 2) {
        uploadWebEventFn('0000130') // 埋点统计：用户名注册密码输入页密码输入错误
      }
    },
    // 手机号注册姓名密码页点击下一步
    'SIGNUPNEXT_PHONE_NEXT': function () {
      uploadWebEventFn('0000010') // 埋点统计：手机号注册姓名密码页点击下一步
    },
    // 手机号注册姓名密码页提示输入错误
    'SIGNUPNEXT_PHONE_ERROR': function () {
      uploadWebEventFn('0000030') // 埋点统计：手机号注册姓名密码页提示输入错误
    },
    // 手机号注册输入验证码页面切换国别码
    'SIGNUP_PHONE_COUNTRYCODE': function () {
      uploadWebEventFn('0000070') // 埋点统计：手机号注册输入验证码页面切换国别码
    },
    // 注册结果
    'SIGNUP_RESULT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0000240', params.status) // 埋点统计：邮箱注册结果
      } else if (params.type === 1) {
        uploadWebEventFn('0000080', params.status) // 埋点统计：手机注册结果
      } else if (params.type === 2) {
        uploadWebEventFn('0000140', params.status) // 埋点统计：用户名注册结果
      } else if (params.from === 'verifyLater') {
        uploadWebEventFn('0000090', params.status) // 埋点统计：稍后验证注册结果
      }
    },
    // 注册页面提示账号已存在
    'SIGNUP_ACCOUNT_EXIST': function () {
      uploadWebEventFn('0000300') // 埋点统计：注册页面提示账号已存在
    },
    // 从账号已存在提示跳转到登录页面
    'SIGNUP_ACCOUNT_EXIST_TO_SIGNIN': function () {
      uploadWebEventFn('0000310') // 埋点统计：从账号已存在提示跳转到登录页面
    },
    // 首个页面输入框手机号不合法
    'INVALID_PHONE': function (params) {
      if (params.type === 'signup') {
        uploadWebEventFn('0000510') // 埋点统计：注册页面首个输入框手机号不合法
      } else if (params.type === 'signin') {
        uploadWebEventFn('0010810') // 埋点统计：登录页面首个输入框手机号不合法
      }
    },
    // 首个页面输入框用户名不合法
    'INVALID_USERNAME': function (params) {
      if (params.type === 'signup') {
        uploadWebEventFn('0000500') // 埋点统计：注册页面首个输入框用户名不合法
      } else if (params.type === 'signin') {
        uploadWebEventFn('0010800') // 埋点统计：登录页面首个输入框用户名不合法
      }
    },
    // 登录页面输入强制跳转到扫码
    'SIGNIN_INPUT_TO_SCAN': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010302') // 埋点统计：登录页面输入邮箱强制跳转到扫码
      } else if (params.type === 1) {
        uploadWebEventFn('0010102') // 埋点统计：登录页面输入手机号强制跳转到扫码
      } else if (params.type === 2) {
        uploadWebEventFn('0010202') // 埋点统计：登录页面输入用户名强制跳转到扫码
      }
    },
    // 登录页面输入强制跳转到下一步登录
    'SIGNIN_INPUT_TO_NEXT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010300') // 埋点统计：登录页面输入并跳转到邮箱登录
      } else if (params.type === 1) {
        uploadWebEventFn('0010100') // 埋点统计：登录页面输入并跳转到手机号登录
      } else if (params.type === 2) {
        uploadWebEventFn('0010200') // 埋点统计：登录页面输入并跳转到用户名登录
      }
    },
    // 登录扫码登录结果
    'SIGNIN_SCAN_RESULT': function (params) {
      // if (params.type === 0) {
      //   uploadWebEventFn('0010303', params.status) // 埋点统计：邮箱登录扫码登录结果
      // } else if (params.type === 1) {
      //   uploadWebEventFn('0010103', params.status) // 埋点统计：手机号登录扫码登录结果
      // } else if (params.type === 2) {
      //   uploadWebEventFn('0010203', params.status) // 埋点统计：用户名登录扫码登录结果
      // }
      uploadWebEventFn('0010401', params.status) // 登录扫码登录结果
    },
    // 登录输入密码登录结果
    'SIGNIN_PASSWORD_RESULT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010301', params.status) // 埋点统计：邮箱登录输入密码登录结果
      } else if (params.type === 1) {
        uploadWebEventFn('0010101', params.status) // 埋点统计：手机号登录输入密码登录结果
      } else if (params.type === 2) {
        uploadWebEventFn('0010201', params.status) // 埋点统计：用户名登录输入密码登录结果
      }
    },
    // 登录页面输入并提示账号不存在
    'SIGNIN_ACCOUNT_NOT_EXIST': function () {
      uploadWebEventFn('0010500') // 埋点统计：登录页面输入并提示账号不存在
    },
    // 从账号不存在提示跳转到注册页面
    'SIGNIN_ACCOUNT_NOT_EXIST_TO_SIGNUP': function () {
      uploadWebEventFn('0010501') // 埋点统计：从账号不存在提示跳转到注册页面
    },
    // 扫码界面切换回登录界面
    'SCAN_TO_SIGNIN': function () {
      uploadWebEventFn('0010402') // 埋点统计：扫码界面切换回登录界面
    },
    // 登录页面切换到扫码页面
    'SIGNIN_TO_SCAN': function () {
      uploadWebEventFn('0010400') // 埋点统计：登录页面切换到扫码页面
    },
    // 注册页面主动跳转到登录页面
    'SINGUP_TO_SIGNIN': function () {
      uploadWebEventFn('0000400') // 埋点统计：注册页面主动跳转到登录页面
    },
    // 登录页面主动跳转到注册页面
    'SINGIN_TO_SIGNUP': function () {
      uploadWebEventFn('0010600') // 埋点统计：登录页面主动跳转到注册页面
    },
    // 登录页面点击重置密码
    'SIGNIN_TO_RESET': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010710') // 埋点统计：邮箱登录页面点击重置密码
      } else if (params.type === 1) {
        uploadWebEventFn('0010700') // 埋点统计：手机号登录页面点击重置密码
      }
    },
    // 重置密码页面验证码错误
    'RESET_PASSWORD_ERROR': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010713') // 埋点统计：邮箱重置密码页面验证码错误
      } else if (params.type === 1) {
        uploadWebEventFn('0010703') // 埋点统计：手机号重置密码页面验证码错误
      }
    },
    // 重置密码结果
    'RESET_PASSWORD_RESULT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010714', params.status) // 埋点统计：邮箱重置密码结果
      } else if (params.type === 1) {
        uploadWebEventFn('0010704', params.status) // 埋点统计：手机号重置密码结果
      }
    },
    // 重置密码页面点击回到登录页
    'RESET_BACK_TO_SIGNIN': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('0010712') // 埋点统计：邮箱重置密码页面点击回到登录页
      } else if (params.type === 1) {
        uploadWebEventFn('0010702') // 埋点统计：手机号重置密码页面点击回到登录页
      }
    },
    // 邮箱重置密码页面获取验证码
    'EMAIL_SEND_CODE': function () {
      uploadWebEventFn('0010711') // 埋点统计：邮箱重置密码页面获取验证码
    },
    // 手机号重置密码页面获取验证码
    'PHONE_RESET_SEND_CODE': function () {
      uploadWebEventFn('0010701') // 埋点统计：手机号重置密码页面获取验证码
    },
    // 手机号注册点击获取手机验证码
    'PHONE_SIGNUP_SEND_CODE': function () {
      uploadWebEventFn('0000040') // 埋点统计：手机号注册点击获取手机验证码
    },
    // 首个页面输入框手机号不合法
    'INVITE_INVALID_USERNAME': function () {
      uploadWebEventFn('105000') // 埋点统计：首个页面输入框手机号不合法
    },
    // 首个页面输入框手机号不合法
    'INVITE_INVALID_PHONE': function () {
      uploadWebEventFn('105010') // 埋点统计：首个页面输入框手机号不合法
    },
    // 邀请页面提示账号已存在
    'INVITE_ACCOUNT_EXIST': function () {
      uploadWebEventFn('106000') // 埋点统计：邀请页面提示账号已存在
    },
    // 邀请登录页面提示密码不合法
    'INVITE_JOIN_PASSWORD_ERROR': function () {
      uploadWebEventFn('106020') // 埋点统计：邀请登录页面提示密码不合法
    },
    // 埋点统计：邀请登录页面登录结果
    'INVITE_JOIN_PASSWORD_RESULT': function (params) {
      uploadWebEventFn('106030', params.status) // 埋点统计：邀请登录页面登录结果
    },
    // 邀请成功界面点击Download/Open Crait
    'INVITE_SUCCESS_OPEN': function () {
      if (params.type === 0) {
        uploadWebEventFn('107060') // 埋点统计：邮箱邀请成功界面点击Download/Open Crait
      } else if (params.type === 1) {
        uploadWebEventFn('108110') // 埋点统计：手机号邀请成功界面点击Download/Open Crait
      } else if (params.type === 2) {
        uploadWebEventFn('109060') // 埋点统计：用户名邀请成功界面点击Download/Open Crait
      } else if (params.type === 3) {
        uploadWebEventFn('106040') // 埋点统计：登录邀请成功界面点击Download/Open Crait
      }
    },
    // 邀请页面输入并跳转到下一页面
    'INVITE_INPUT_NEXT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('107000') // 埋点统计：邀请页面输入并跳转到邮箱注册页面
      } else if (params.type === 1) {
        uploadWebEventFn('108000') // 埋点统计：邀请页面输入并跳转到手机号注册页面
      } else if (params.type === 2) {
        uploadWebEventFn('109000') // 埋点统计：邀请页面输入并跳转到用户名注册页面
      }
    },
    // 邀请页面返回上一步
    'INVITE_BACK': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('107010') // 埋点统计：邮箱邀请密码输入页返回上一步
      } else if (params.type === 1) {
        uploadWebEventFn('108010') // 埋点统计：手机号邀请姓名密码页返回上一步
      } else if (params.type === 2) {
        uploadWebEventFn('109010') // 埋点统计：用户名邀请密码输入页返回上一步
      } else if (params.type === 3) {
        uploadWebEventFn('108080') // 埋点统计：手机号邀请输入验证码页面返回上一步
      }
    },
    // 手机号邀请姓名密码页提示输入错误
    'INVITENEXT_PHONE_ERROR': function () {
      uploadWebEventFn('108030') // 埋点统计：手机号邀请姓名密码页提示输入错误
    },
    // 邀请注册页点击查看用户协议
    'INVITENEXT_AGGREMENT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('107040') // 埋点统计：邮箱邀请注册页点击查看用户协议
      } else if (params.type === 1) {
        uploadWebEventFn('108040') // 埋点统计：手机号邀请注册页点击查看用户协议
      } else if (params.type === 2) {
        uploadWebEventFn('109040') // 埋点统计：用户名邀请注册页点击查看用户协议
      }
    },
    // 手机号邀请姓名密码页点击下一步
    'INVITENEXT_PHONE_NEXT': function () {
      uploadWebEventFn('108050') // 埋点统计：手机号邀请姓名密码页点击下一步
    },
    // 手机号邀请注册输入验证码页面切换国别码
    'INVITE_PHONE_COUNTRYCODE': function () {
      uploadWebEventFn('108060') // 埋点统计：手机号邀请注册输入验证码页面切换国别码
    },
    // 手机号邀请注册页面获取验证码
    'PHONE_INVITE_SEND_CODE': function () {
      uploadWebEventFn('108070') // 埋点统计：手机号邀请注册页面获取验证码
    },
    // 邀请注册结果
    'INVITE_RESULT': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('107050', params.status) // 埋点统计：邮箱邀请注册结果
      } else if (params.type === 1) {
        uploadWebEventFn('108100', params.status) // 埋点统计：手机邀请注册结果
      } else if (params.type === 2) {
        uploadWebEventFn('109050', params.status) // 埋点统计：用户名邀请注册结果
      } else if (params.from === 'verifyLater') {
        uploadWebEventFn('108120', params.status) // 埋点统计：稍后验证邀请注册结果
      }
    },
    // 邀请页面点击切换账号
    'INVITE_SWITCH_BACK': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('107020') // 埋点统计：邀请邮箱注册页面点击切换账号
      } else if (params.type === 1) {
        uploadWebEventFn('108020') // 埋点统计：邀请手机号注册页面点击切换账号
      } else if (params.type === 2) {
        uploadWebEventFn('109020') // 埋点统计：邀请手机号注册页面点击切换账号
      } else if (params.type === 3) {
        uploadWebEventFn('106010') // 埋点统计：邀请登录页面点击切换账号
      }
    },
    //
    'INVITENEXT_DONE_ERROR': function (params) {
      if (params.type === 0) {
        uploadWebEventFn('107030') // 埋点统计：邮箱邀请密码输入页密码输入错误
      } else if (params.type === 1) {
        uploadWebEventFn('108090') // 埋点统计：手机号邀请输入验证码页面输入错误
      } else if (params.type === 2) {
        uploadWebEventFn('109030') // 埋点统计：用户名邀请密码输入页密码输入错误
      }
    },
    'VIEW': function (params) {
      if (params.type) {
        uploadWebEventFn('tView', '', 0) // 埋点统计：微信打开页面
      } else {
        uploadWebEventFn('tView', '', 1) // 埋点统计：其他打开页面
      }
    },
    'START': function (params) {
      uploadWebEventFn('tStart', '', params.type) // 埋点统计：首页_开始安全通信 输入框手机号不合法
    },
    'OPENAPP': function (params) {
      uploadWebEventFn('tOpenApp', '', params.type) // 埋点统计：点击app中打开 首页
    },
    'SWITCH': function (params) {
      uploadWebEventFn('tSwitch') // 埋点统计：老用户点击切换账号
    },
    'REGISTER': function (params) {
      uploadWebEventFn('rRegister', '', params.type, params.result) // 埋点统计：新用户注册结果
    },
    'ACCEPT': function (params) {
      uploadWebEventFn('rAccept', '', '', params.result) // 埋点统计：老用户接收邀请结果
    },
    'DOWNLOAD': function (params) {
      uploadWebEventFn('tDownload', '', params.type) // 埋点统计：点击打开/下载app
    }
  }
  fn[type](params)
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/UploadWebEvent.js